export const PlayerSearchTabTypes = {
  PLAYER_ID: 1,
  USERNAME: 2,
};

export const playerSearchTabs = [
  {
    value: PlayerSearchTabTypes.PLAYER_ID,
    name: 'Search by player id',
  },
  {
    value: PlayerSearchTabTypes.USERNAME,
    name: 'Search by username',
  },
];
